"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NumberPgHandler", {
    enumerable: true,
    get: function() {
        return NumberPgHandler;
    }
});
const _numbergeneralhandler = require("./number.general.handler");
const _decimalpghandler = require("~/db/field-handler/handlers/decimal/decimal.pg.handler");
let NumberPgHandler = class NumberPgHandler extends _decimalpghandler.DecimalPgHandler {
    constructor(...args){
        super(...args), this.numberGeneralHandler = new _numbergeneralhandler.NumberGeneralHandler(), this.parseUserInput = this.numberGeneralHandler.parseUserInput;
    }
};
